import { Injectable } from '@angular/core';
import { Secure } from '@cv-invision/core';
import { PERMISSION, MAINPATHS } from '../model/global-configuration.constant';
import {
	PRODUCTS_MENU,
	MAPPERS_MENU,
	ORDERS_MONITOR_MENU,
	APPSCOPE_CONFIG_MENU,
	MONITOR_MENU,
	NEXSYS_MONITOR_MENU,
	VALUTRUST_MONITOR_MENU,
	XPANSE_MONITOR_MENU,
	FNC_MONITOR_MENU,
	NEXSYS_ORPHAND_MONITOR_MENU,
	ORDERS_EXTERNAL_MONITOR_MENU,
	EVO_MONITOR_MENU,
	DELIVERY_ASSETS_CONFIG_MENU,
	MI_MUTUAL_MENU,
	RELIANCE_MENU,
	EMAIL_LIST_BY_INTEGRATION_CONFIG_MENU,
	VALUELINK_MENU,
	CONNEXIONS_MENU,
	LENDING_QB_MENU,
	CLIENT_IDENTIFIER_CONFIG_MENU,
	OUTGOING_EVENTS_HYBRID_ROUTES
} from '../model/global-configuration-menu.model';


@Injectable()
export class  GlobalConfigurationMenuHandleService {
private global_configuration_menu:Array<object>;
private monitorMenu:Array<object>;
private monitorDefaultUrl:string;

	@Secure(PERMISSION.ORDERS_PRODUCTS)
	private accessProducts(): void {
		this.global_configuration_menu = [...this.global_configuration_menu , ...PRODUCTS_MENU];
	}

	@Secure(PERMISSION.ORDERS_MAPPERS)
	private accessIntegrationMappers(): void {
		this.global_configuration_menu  = [...this.global_configuration_menu , ...MAPPERS_MENU];
	}

	@Secure(PERMISSION.NEXSYS)
	private accessNexsysMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.NEXSYS;
		this.monitorMenu = [...this.monitorMenu , NEXSYS_MONITOR_MENU];
	}

	@Secure(PERMISSION.NEXSYS_ORPHAN)
	private accessNexsysOrphanMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORPHANS;
		this.monitorMenu = [...this.monitorMenu , NEXSYS_ORPHAND_MONITOR_MENU];
	}

	@Secure(PERMISSION.VALUTRUST)
	private accessValutrustMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.VALUTRUST;
		this.monitorMenu  = [...this.monitorMenu  , VALUTRUST_MONITOR_MENU];
	}

	@Secure(PERMISSION.XPANSE)
	private accessXpanseMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.XPANSE;
		this.monitorMenu  = [...this.monitorMenu  , XPANSE_MONITOR_MENU];
	}

	@Secure(PERMISSION.FNC)
	private accessFNCMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.FNC;
		this.monitorMenu  = [...this.monitorMenu  , FNC_MONITOR_MENU];
	}

	@Secure(PERMISSION.ORDERS_EXTERNAL)
	private accessOrderExternalMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERSEXTERNAL;
		this.monitorMenu  = [...this.monitorMenu  , ORDERS_EXTERNAL_MONITOR_MENU];
	}

	@Secure(PERMISSION.EVO)
	private accessEvoMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERSEXTERNAL;
		this.monitorMenu  = [...this.monitorMenu  , EVO_MONITOR_MENU];
	}

	@Secure(PERMISSION.ORDERS)
	private accessOrdersListMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERS;
		this.monitorMenu  = [...this.monitorMenu  , ORDERS_MONITOR_MENU];
		this.global_configuration_menu = [...this.global_configuration_menu, ...EMAIL_LIST_BY_INTEGRATION_CONFIG_MENU ];
	}

	@Secure(PERMISSION.ORDERS)
	private accessOutgoingEventsHybrid(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERS;
		this.global_configuration_menu = [...this.global_configuration_menu, ...OUTGOING_EVENTS_HYBRID_ROUTES ];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private accessClientIdentifier(): void {
		this.global_configuration_menu = [...this.global_configuration_menu, ...CLIENT_IDENTIFIER_CONFIG_MENU ];
	}

	@Secure(PERMISSION.ORDERS_MAPPERS)
	private accessAppscopeConfiguration(): void {
		this.global_configuration_menu = [...this.global_configuration_menu , ...APPSCOPE_CONFIG_MENU];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private accessDeliveryAssetsConfiguration(): void {
		this.global_configuration_menu = [...this.global_configuration_menu, ...DELIVERY_ASSETS_CONFIG_MENU ];
	}

	@Secure(PERMISSION.MI_MUTUAL)
	private accessMiMutual(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.MIMUTUAL;
		this.monitorMenu  = [...this.monitorMenu  , MI_MUTUAL_MENU];
	}

	@Secure(PERMISSION.RELIANCE_FIRST)
	private accessRelianceFirst(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.RELIANCEFIRST;
		this.monitorMenu  = [...this.monitorMenu  , RELIANCE_MENU];
	}

	@Secure(PERMISSION.VALUE_LINK)
	private accessValueLink(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.RELIANCEFIRST;
		this.monitorMenu  = [...this.monitorMenu  , VALUELINK_MENU];
	}

	@Secure(PERMISSION.CONNEXIONS)
	private accessConnexions(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.RELIANCEFIRST;
		this.monitorMenu  = [...this.monitorMenu  , CONNEXIONS_MENU];
	}

	@Secure(PERMISSION.LENDING_QB)
	private accessLendingQb(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.RELIANCEFIRST;
		this.monitorMenu  = [...this.monitorMenu  , LENDING_QB_MENU];
	}

	/**
	 * monitor menu build
	 */
	private accessMonitor(): void {
		this.monitorMenu = [];
		this.monitorDefaultUrl = null;
		this.accessNexsysMonitor();
		this.accessNexsysOrphanMonitor();
		this.accessValutrustMonitor();
		this.accessXpanseMonitor();
		this.accessFNCMonitor();
		this.accessOrderExternalMonitor();
		this.accessEvoMonitor();
		this.accessValueLink();
		this.accessLendingQb();
		this.accessConnexions();
		this.accessOrdersListMonitor();
		this.accessOutgoingEventsHybrid();
		this.accessClientIdentifier();
		//this.accessDeliveryAssetsConfiguration();
		this.accessMiMutual();
		this.accessRelianceFirst();
		
		MONITOR_MENU[0].items = this.monitorMenu;
		MONITOR_MENU[0].route = `${MAINPATHS.MAIN}/${this.monitorDefaultUrl}`;
		if(this.monitorMenu.length){
			this.global_configuration_menu = [...this.global_configuration_menu , ...MONITOR_MENU];
		}
	}

	/**
	 * set Menu navigation base on permissions
	 */
	public getMenuNavigation(): Array<object> {
		this.global_configuration_menu = [];
		this.accessProducts();
		this.accessIntegrationMappers();
		this.accessMonitor();
		this.accessAppscopeConfiguration();
		this.accessDeliveryAssetsConfiguration();
		return this.global_configuration_menu;
	}
}
